// ABOUTME: Ticket-mint fetch + WebSocket URL builder for live conversation
// mode (#2609 Part 3). A browser WebSocket handshake can't send an
// Authorization header, so a short-lived single-use ticket (POST
// /agent/voice/live/ticket, normal bearer auth) stands in for one.

import { fetchWithAuthRetry, getBaseUrl } from '@/api/client'
import { useAuthStore } from '@/stores/useAuthStore'

/** A ticket for a call with Marketing, or with the team member `roleId`. */
export async function mintLiveVoiceTicket(roleId?: string): Promise<string> {
  const baseUrl = getBaseUrl()
  const user = useAuthStore.getState().user
  const businessId = (user as Record<string, unknown> | null)?.default_business_id as
    | string
    | undefined

  const response = await fetchWithAuthRetry((token) => {
    const headers: Record<string, string> = {}
    if (token) headers['Authorization'] = `Bearer ${token}`
    if (businessId) headers['X-Business-ID'] = businessId
    const query = roleId ? `?role_id=${encodeURIComponent(roleId)}` : ''
    return fetch(`${baseUrl}/agent/voice/live/ticket${query}`, { method: 'POST', headers })
  })

  if (!response.ok) {
    throw new Error(`Could not start live conversation (${response.status})`)
  }
  const body = (await response.json()) as { ticket: string }
  return body.ticket
}

export function buildLiveVoiceWsUrl(ticket: string): string {
  const httpBase = getBaseUrl()
  const wsBase = httpBase.replace(/^http/, 'ws')
  return `${wsBase}/agent/voice/live?ticket=${encodeURIComponent(ticket)}`
}
